import { jsx as _jsx } from "react/jsx-runtime";
import { omitThemingProps, styled, useStyleConfig, vui } from '../core';
import { cs } from '../utils';
export const GridBase = styled.divBox `
  display: grid;
`;
/** Displays a basic grid wrapper. */
export const Grid = vui((props, ref) => {
    const { className, ...rest } = omitThemingProps(props);
    const styles = useStyleConfig('Grid', props);
    return _jsx(GridBase, { className: cs('vui-grid', className), ref: ref, ...styles, ...rest });
});
Grid.displayName = 'Grid';
export default Grid;
